module.exports = __webpack_public_path__ + "static/media/Loader.6ab97d8a.gif";